import axios from 'axios';
import { reset } from 'redux-form';
import { AuthActionTypes } from '../../types';
import {
  APIServiceConstants,
  BlueprintAPI,
  BlueprintJSONAPI,
  APIMethods,
  getUrl,
} from '../BlueprintAPI';

const { SERVICE } = APIServiceConstants;

export const AuthActionCreators = {
  checkToken: () => async (dispatch) => {
    const sessionToken = await localStorage.getItem('sToken');
    const refreshToken = await localStorage.getItem('rToken');
    if (!sessionToken || !refreshToken) {
      dispatch({
        type: AuthActionTypes.AUTH_STATUS,
        error: 'No Auth',
      });
    } else {
      try {
        await BlueprintAPI(
          SERVICE,
          'token',
          {
            operation: 'check',
            sessionToken,
            refreshToken,
          },
          `${window.blueprintGetApiBaseURL()}/${SERVICE}/token`,
        );
        dispatch({
          type: AuthActionTypes.AUTH_STATUS,
          error: null,
        });
      } catch (e) {
        dispatch({
          type: AuthActionTypes.AUTH_STATUS,
          error: 'No Auth',
        });
      }
    }
  },
  register: (data) => async (dispatch) => {
    dispatch({
      type: AuthActionTypes.REGISTER_REQ,
    });
    try {
      const response = await axios.post(
        `${window.blueprintGetApiBaseURL()}/${SERVICE}/register`,
        JSON.stringify(data),
      );
      if (response.data.status === 200) {
        dispatch({
          type: AuthActionTypes.REGISTER_RES,
          payload: response.data.message,
          error: null,
        });
      } else {
        dispatch({
          type: AuthActionTypes.REGISTER_RES,
          error: response.data.message || 'An error occurred while registering',
        });
      }
    } catch (e) {
      dispatch({
        type: AuthActionTypes.REGISTER_RES,
        error: e.message,
      });
    }
  },
  login: (data) => async (dispatch) => {
    dispatch({
      type: AuthActionTypes.LOGIN_REQ,
    });
    try {
      const response = await axios.post(
        getUrl(SERVICE, 'login'),
        JSON.stringify(data),
        { headers: { 'Content-Type': 'application/json' } },
      );
      if (response.data.status === 200) {
        localStorage.setItem('sToken', response.data.sessionToken);
        localStorage.setItem('rToken', response.data.refreshToken);
        dispatch({
          type: AuthActionTypes.LOGIN_RES,
          error: null,
        });

        return { error: null };
      }
      const error = response.data.message || 'An error occurred while logging in';

      dispatch({
        type: AuthActionTypes.LOGIN_RES,
        error,
      });

      return { error };
    } catch (e) {
      const error = e.response && e.response.data && e.response.data.error
        ? e.response.data.error
        : 'An error occurred while logging in';

      dispatch({
        type: AuthActionTypes.LOGIN_RES,
        error,
      });

      return {
        errorCode: e.response.status,
        error,
      };
    }
  },
  updatePassword: (data) => async (dispatch) => {
    dispatch({
      type: AuthActionTypes.UPDATE_PW_REQ,
    });
    try {
      await BlueprintJSONAPI(APIMethods.POST, SERVICE, 'updatePassword', data);
      dispatch({
        type: AuthActionTypes.UPDATE_PW_RES,
      });
    } catch (e) {
      console.log('e', e);
      dispatch({
        type: AuthActionTypes.UPDATE_PW_RES,
        error: e.data.error ? e.data.error : 'Something went wrong',
      });
    }
  },
  resetForm: (formName) => async (dispatch) => {
    dispatch(reset(formName));
  },
  logout: () => async (dispatch) => {
    await localStorage.removeItem('sToken');
    await localStorage.removeItem('rToken');
    dispatch({
      type: 'LOGOUT',
    });
  },
};

export default AuthActionCreators;
